import { render, staticRenderFns } from "./holidayset.vue?vue&type=template&id=013cf82a&scoped=true"
import script from "./holidayset.vue?vue&type=script&lang=js"
export * from "./holidayset.vue?vue&type=script&lang=js"
import style0 from "./holidayset.vue?vue&type=style&index=0&id=013cf82a&scoped=true&lang=css"
import style1 from "./holidayset.vue?vue&type=style&index=1&id=013cf82a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013cf82a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013cf82a')) {
      api.createRecord('013cf82a', component.options)
    } else {
      api.reload('013cf82a', component.options)
    }
    module.hot.accept("./holidayset.vue?vue&type=template&id=013cf82a&scoped=true", function () {
      api.rerender('013cf82a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/holiday/holidayset.vue"
export default component.exports